import React from 'react';

import { getFormattedPrice } from '@tools/utils/common.tsx';
import type { PosPaymentSummary } from '../../types';

export interface PosPaymentResultSummaryProps {
  summary: PosPaymentSummary;
  currency: string;
}

export const PosPaymentResultSummary: React.FC<PosPaymentResultSummaryProps> = ({ summary, currency }) => (
  <section className="pos-screen__payment-summary" aria-label="Resumen de pagos aplicados">
    <h2>Pagos recientes</h2>
    <p>Total recibido: {getFormattedPrice(summary.totalTendered, currency)}</p>
    <p>Saldo pendiente: {getFormattedPrice(summary.outstanding, currency)}</p>
    <p>Vuelto: {getFormattedPrice(summary.changeDue, currency)}</p>
    {summary.registerDebt ? <p className="pos-screen__warning">Deuda registrada por {getFormattedPrice(summary.outstanding, currency)}</p> : null}
  </section>
);

export default PosPaymentResultSummary;
